module.exports = __webpack_public_path__ + "img/agent_four.5183d596.webp";